import { createContext, useContext, useState } from "react";
import { translations } from "@/i18n";
import api from "@/lib/api";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("bvd_lang") || "fr");
  const change = (l, { persist = true } = {}) => {
    localStorage.setItem("bvd_lang", l); setLang(l);
    if (persist && localStorage.getItem("bvd_token")) api.patch("/auth/me/lang", { lang: l }).catch(() => {});
  };
  const t = (key) => translations[lang][key] ?? translations.fr[key] ?? key;
  return <I18nCtx.Provider value={{ lang, setLang: change, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
